import { get } from 'lodash';
import Registry from 'cartware-registry';
import Dispatcher from 'cartware-component-dispatcher';
import Config from 'cartware-config';
import Handles from './system/handles';

const rootInfoObject = get(window, 'komar');

Config.populate(rootInfoObject);

const dispatcher = new Dispatcher(Handles);
Registry.register('system.dispatcher', dispatcher);
dispatcher.dispatch(Config.get('handles', []));
